// extracted by mini-css-extract-plugin
export default {"infoIconWrapper":"PreventiveRecallList_infoIconWrapper__3Gnhp"};